import script from "./AddAnArticle.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddAnArticle.vue?vue&type=script&setup=true&lang=ts"

import "./AddAnArticle.vue?vue&type=style&index=0&id=1b44d028&lang=css"

const __exports__ = script;

export default __exports__